module.exports = __webpack_public_path__ + "files/059fcccd9e5dba748bf7ff2cea599ba0.png";